import { render, staticRenderFns } from "./side_types.vue?vue&type=template&id=579a03a0&"
import script from "./side_types.vue?vue&type=script&lang=js&"
export * from "./side_types.vue?vue&type=script&lang=js&"
import style0 from "./side_types.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports